module.exports = __webpack_public_path__ + "static/img/header_bg.7836bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/header/header_bg.png
// module id = sqTd
// module chunks = 1